import { paths } from 'src/routes/paths';
import type { NavBasicProps } from './main/nav-basic';

export const NAV_ITEMS: NavBasicProps['data'] = [
  {
    title: 'Beranda',
    path: paths.home,
  },
  {
    title: 'Tentang Kami',
    path: paths.aboutUs,
    children: [
      {
        title: 'Sejarah Puspa Jaya',
        path: `${paths.aboutUs}`,
      },
      {
        title: 'Visi & Misi',
        path: `${paths.aboutUs}#visimisi`,
      },
      {
        title: 'Penghargaan Puspa Jaya',
        path: `${paths.aboutUs}#penghargaan`,
      },
    ],
  },
  {
    title: 'Layanan',
    path: '/components',
    children: [
      {
        title: 'Bus AKAP',
        path: paths.busAkap,
      },
      {
        title: 'Bus Pariwisata',
        path: paths.busPariwisata,
      },
    ],
  },
  {
    title: 'Agen',
    path: paths.agent,
  },
  {
    title: 'Panduan',
    path: paths.panduan,
  },
];
